import { Capacitor } from "@capacitor/core";

/**
 * Check if the app is running as a native Capacitor app
 * @returns {boolean} True if running as a native app
 */
export const isCapacitorApp = () => {
  try {
    return Capacitor.isNativePlatform();
  } catch (error) {
    console.error("Error checking Capacitor platform:", error);
    return false;
  }
};

/**
 * Get the platform the app is running on
 * @returns {string} 'ios', 'android', or 'web'
 */
export const getCapacitorPlatform = () => {
  try {
    return Capacitor.getPlatform();
  } catch (error) {
    console.error("Error getting Capacitor platform:", error);
    return "web";
  }
};

/**
 * Get headers for Capacitor requests
 * @returns {Object} Headers including x-client-type when running native
 */
export const getCapacitorHeaders = () => {
  return isCapacitorApp() ? { "x-client-type": "capacitor" } : {};
};
